import { Table, Flex, Button, Modal } from "@mantine/core";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import dayjs from "dayjs";
import styled from "styled-components";
import "dayjs/locale/tr";
import CustomPagination from "../common/CustomPagination";
import {
  createWorkPermit,
  deleteWorkPermit,
  getWorkPermitsForEmployee,
} from "../../api/workPermitApi";
import WorkPermitCreateModal from "./WorkPermitsCreateModal";
import PlusIcon from "../common/Icons/PlusIcon";
import { theme } from "../../theme";
import TableDeleteButton from "../common/Buttons/TableDeleteButton";
import AreYouSureModal from "../common/Modals/AreYouSureModal";
import { deleteNotification } from "../../utils/useNotification";
dayjs.locale("tr");

const WorkPermitsTable = () => {
  const { id }: any = useParams();
  const [tableData, setTableData] = useState<any>();
  const [itemToDeleteId, setitemToDeleteId] = useState<any>();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  //for pagination
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState<any>(
    window.devicePixelRatio === 1.25 ? "4" : "5"
  );
  const [totalPages, setTotalPages] = useState(1);

  //for modal
  const [opened, setOpened] = useState(false);

  const getTableData = async () => {
    try {
      const { data }: any = await getWorkPermitsForEmployee({
        pageNumber: page,
        limit: limit,
        employeeId: id,
      });
      setTableData(data?.data);
      setPage(data?.meta?.page);
      setLimit(data?.meta?.limit);
      setTotalPages(data?.meta?.totalPages);
    } catch (error) {}
  };

  const handleDeleteClick = async (workPermitId: any) => {
    try {
      const { data }: any = await deleteWorkPermit({
        workPermitId,
        employeeId: id,
      });
      deleteNotification(data?.success);
      getTableData();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    if (page) {
      getTableData();
    }
  }, [page]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        gap: "15px  ",
      }}
    >
      <Flex w={"100%"} justify={"space-between"} align={"center"}>
        <div
          style={{
            fontWeight: "600",
            color: "black",
            fontSize: "20px",
            lineHeight: "24px",
          }}
        >
          İzin Tablosu
        </div>
        <Button
          color={theme.colors.brand.normal}
          leftSection={<PlusIcon />}
          onClick={() => setOpened(true)}
        >
          Yeni İzin
        </Button>
      </Flex>
      <div
        style={{
          overflowY: "auto",
          minHeight: "360px",
          maxHeight: "360px",
          width: "100%",
          border: "1px solid #D1D5DB",
          borderRadius: "6px",
        }}
      >
        {/* <Flex p={"12px 16px"} justify={"space-between"}>
          <Flex gap={8}>
            <CustomDatePicker
              placeholder="Tarih Seçiniz"
              onChange={(e: any) => {
                setSelectedDate(e);
                setFormattedSelectedDate(
                  e ? dayjs(e).format("YYYY-MM-DD") : ""
                );
              }}
            />
          </Flex>
        </Flex> */}
        <Table
          style={{
            borderCollapse: "separate",
          }}
          verticalSpacing="sm"
          horizontalSpacing="md"
        >
          <Table.Thead
            style={{
              background: "#EEF2FF",
            }}
          >
            <Table.Tr>
              <StyledTableTh style={{ width: "15%" }}>
                İzin Başlangıç Tarihi
              </StyledTableTh>
              <StyledTableTh style={{ width: "15%" }}>
                İzin Bitiş Tarihi
              </StyledTableTh>
              <StyledTableTh style={{ width: "15%" }}>İzin Tipi</StyledTableTh>
              <StyledTableTh style={{ width: "15%" }}>İzin Notu</StyledTableTh>

              <StyledTableTh style={{ width: "0%" }}></StyledTableTh>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {tableData?.map((data: any) => (
              <Table.Tr key={data._id}>
                <Table.Td>{dayjs(data.start).format("DD/MM/YYYY")}</Table.Td>
                <Table.Td>{dayjs(data.end).format("DD/MM/YYYY")}</Table.Td>
                <Table.Td>
                  {data.type === "paid" ? "Ücretli" : "Ücretsiz"}
                </Table.Td>
                <Table.Td>
                  {data.note ? data.note : "Not mevcut değil."}
                </Table.Td>
                <Table.Td>
                  <Flex>
                    <TableDeleteButton
                      onClick={(e: any) => {
                        e.stopPropagation();
                        setitemToDeleteId(data?.id);
                        setOpenDeleteModal(true);
                      }}
                    />
                  </Flex>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </div>

      <div
        style={{
          alignSelf: "center",
          position: "absolute",
          bottom: "-10px",
        }}
      >
        <CustomPagination total={totalPages} value={page} onChange={setPage} />
      </div>

      <Modal
        opened={opened}
        title="İzin Oluşturma"
        centered
        onClose={() => {
          setOpened(false);
        }}
        withCloseButton={true}
        keepMounted={false}
        key={id}
      >
        <WorkPermitCreateModal
          closeModal={() => setOpened(false)}
          reFetchData={getTableData}
        />
      </Modal>

      <AreYouSureModal
        opened={openDeleteModal}
        setOpened={setOpenDeleteModal}
        proccessFunc={() => handleDeleteClick(itemToDeleteId)}
        title="İzni Sil"
        text="Bu izni silmek istediğinizden emin misiniz?"
        confirmButtonText="Sil"
        cancelButtonText="Vazgeç"
      />
    </div>
  );
};

export default WorkPermitsTable;

const StyledTableTh = styled(Table.Th)<any>`
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  text-align: left;
  color: #4c4c4c;
`;
